import type {Pointer, Pointers} from '@wix/document-services-types'
import {DATA_TYPES} from '../../../constants/constants'
import type {DataModelAPI} from '../../dataModel/dataModel'
import type {DalValue} from '@wix/document-manager-core'

export class ComponentDataRepository {
    constructor(private readonly dataModelAPI: DataModelAPI, private readonly pointers: Pointers) {}

    getComponentDataItem(compPointer: Pointer): DalValue | null {
        const dataPointer = this.getComponentDataPointer(compPointer)
        const pagePointer = this.pointers.structure.getPageOfComponent(compPointer)
        if (!dataPointer?.id || !pagePointer.id) return null
        return this.dataModelAPI.getItem(dataPointer.id, DATA_TYPES.data, pagePointer.id)
    }

    getComponentDataPointer(compPointer: Pointer): Pointer | undefined {
        return this.dataModelAPI.components.getItemPointer(compPointer, DATA_TYPES.data)
    }
}
